// アニマルID でログインしたときの ID トークン。アニマルID からもログアウトするときに id_token_hint として渡す
export const ID_TOKEN_KEY = 'idToken';
export const PARTNER_ID_KEY = 'partnerId';

type SignInTokens = { access: string; refresh: string; idToken?: string };

/** ログインで受け取ったトークンを保存する。ID トークンが無いログイン(パスワード)では、前のログインの ID トークンを消す */
export const saveTokens = ({ access, refresh, idToken }: SignInTokens) => {
  localStorage.setItem('accessToken', access);
  localStorage.setItem('refreshToken', refresh);
  if (idToken) {
    localStorage.setItem(ID_TOKEN_KEY, idToken);
  } else {
    localStorage.removeItem(ID_TOKEN_KEY);
  }
};

/** ログアウト・認証切れで、保存したトークンと選択中の取引先を消す */
export const clearSavedAuth = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(PARTNER_ID_KEY);
};
